import * as Sentry from '@sentry/nuxt';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.afterEach((to, from) => {
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `${from.path} → ${to.path}`,
      level: 'info',
      data: {
        from: from.path,
        to: to.path
      }
    });
  });
});
